import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { TRAVEL_CARD_EXTERNAL_CUSTOMER, TRAVEL_CARD_GROUPING_CONFIG } from 'api/react-query/keys'
import type { ExternalCustomer, GroupingConfig, TravelManagementCompany } from '../types'
import { getExternalCustomer, getGroupingConfig, registerExternalCustomer, registerGroupingConfig } from './endpoints'

export const useExternalCustomer = (customerId: string) =>
  useQuery({
    queryKey: [TRAVEL_CARD_EXTERNAL_CUSTOMER, customerId],
    queryFn: () => getExternalCustomer(customerId),
  })

export const useRegisterExternalCustomer = (customerId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (externalCustomer: ExternalCustomer) => registerExternalCustomer(customerId, externalCustomer),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TRAVEL_CARD_EXTERNAL_CUSTOMER, customerId] })
    },
  })
}

export const useGroupingConfig = (customerId: string, tmc: TravelManagementCompany) =>
  useQuery({
    queryKey: [TRAVEL_CARD_GROUPING_CONFIG, customerId, tmc],
    queryFn: () => getGroupingConfig(customerId, tmc),
  })

export const useRegisterGroupingConfig = (customerId: string, tmc: TravelManagementCompany) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (groupingConfig: GroupingConfig) => registerGroupingConfig(customerId, tmc, groupingConfig),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TRAVEL_CARD_GROUPING_CONFIG, customerId, tmc] })
    },
  })
}
